<template>
  <div class="main-content">
    <div class="card">
      <div class="card-body">
        <div class="flex justify-content-end gap mb-1">
          <LoadingButton
            title="Удалить выбранные"
            :loading="loading"
            type="button"
            class="btn btn-outline-danger"
            :color="$constants.DANGER_COLOR"
            :onClick="() => deleteRecords()"
          />
          <LoadingButton
            title="Скачать выбранные"
            :loading="downloadLoading"
            type="button"
            class="btn btn-outline-info"
            :color="$constants.PRIMARY_COLOR"
            :onClick="() => downloadSelected()"
          />
          <LoadingButton
            title="Обновить"
            :loading="loading"
            type="button"
            class="btn btn-outline-info"
            :color="$constants.PRIMARY_COLOR"
            :onClick="() => getRecords(paginator?.current_page ?? 1)"
          />
        </div>
        <pulse-loader :loading="loading" :color="$constants.LOADING_COLOR" class="text-center"/>
        <template v-if="!loading && files.length">
          <table class="table mt-1 table-sm table-hover">
            <thead>
            <tr>
              <th></th>
              <th><input type="checkbox" @change="selectAll"/></th>
              <th>файл</th>
              <th>скачан</th>
              <th>Создан</th>
              <th>Дата</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(r,i) in files">
              <td>{{ (i + 1) + ((paginator.current_page - 1) * paginator.per_page) }}</td>
              <td><input type="checkbox" @change="holdShift(r.id, $event)" v-model="selected[r.id]"/></td>
              <td>{{ r.file_name }}</td>
              <td>
                <p v-for="d in (r?.details?.downloaded ?? [])">({{ d.user_id }}) {{ d.user_name }}
                  <span class="text-muted">({{ printDate(d.date) }})</span></p>
              </td>
              <td>{{ r.details?.uploaded_by?.user_name }}</td>
              <td>{{ printDate(r.created_at) }}</td>
            </tr>
            </tbody>
          </table>
        </template>
        <div class="text-right">
          <paginate v-if="paginator"
                    v-model="paginator.current_page"
                    :page-count="paginator.last_page"
                    ref="Pagination"
                    :page-range="11"
                    :margin-pages="2"
                    :click-handler="getRecords"
                    :prev-text="'&laquo'"
                    :next-text="'&raquo'"
                    :container-class="'pagination'"
                    :prev-class="'page-item'"
                    :prev-link-class="'page-link'"
                    :page-class="'page-item'"
                    :page-link-class="'page-link'"
                    :next-class="'page-item'"
                    :next-link-class="'page-link'"
                    :active-class="'active green_btn'">
          </paginate>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import api from "@/api";
import Paginate from 'vuejs-paginate'
import LoadingButton from "@/components/buttons/LoadingButton.vue";

export default {
  title: 'Файлы',
  components: {
    LoadingButton,
    Paginate,
  },
  data() {
    return {
      isShift: false,
      loading: false,
      downloadLoading: false,
      files: [],
      selected: {},
      paginator: null,
    }
  },
  created() {
    document.onkeydown = (e) => this.updateShiftBtn(e);
    document.onkeyup = (e) => this.updateShiftBtn(e, true);
    this.getRecords()
  },
  beforeDestroy() {
    document.onkeydown = null;
    document.onkeyup = null;
  },
  methods: {
    async deleteRecords() {
      const selected = Object.keys(this.selected).filter((i) => this.selected[i]);
      if (!selected.length) return;
      this.loading = true;
      const {data} = await api.post('/new/files/delete', {selected});
      if (data.success) {
        toastr['success'](data.message || 'сохранено', 'Успешно')
        this.getRecords(this.paginator?.current_page ?? 1);
      } else {
        toastr['warning'](data.message || 'ошибка сервера', 'Неуспешно')
      }
      this.loading = false;
    },
    updateShiftBtn(e, clear = false) {
      const key = e.keyCode;
      this.isShift = clear ? false : key === 16;
    },
    async getRecords(page = 1) {
      this.loading = true;
      let {data: r_data} = await api.post('/new/files?page=' + page, {})
      if (r_data.success) {
        const {data, ...pagination} = r_data.records;
        this.paginator = pagination;
        this.files = data;
      }
      this.loading = false;
    },
    holdShift(id, e) {
      if (!this.isShift) return;
      const records = [...this.files];
      let arr = [];
      let addRecord = false;
      let loopClose = false;
      records.forEach((d) => {
        if (loopClose) return;
        if (d.id === +id) {
          loopClose = true;
          return;
        }
        if (this.selected[d.id]) {
          arr = [];
          addRecord = true;
          return;
        }
        if (addRecord) arr.push(d.id);
      })
      arr.forEach((d) => {
        this.selected[d] = true;
      })
    },
    async downloadSelected() {
      const selected = Object.keys(this.selected).filter((i) => this.selected[i]);
      if (!selected.length) return;
      this.downloadLoading = true;
      const {data} = await api.post('/new/files/download', {
        selected
      })
      if (data.success) {
        this.selected = {};
        window.location.href = data.link;
      }
      this.downloadLoading = false;
    },
    selectAll(e) {
      if (e.target.checked) {
        this.selected = this.files.reduce((acc, f) => {
          acc[f.id] = true;
          return acc;
        }, {})
      } else {
        this.selected = {};
      }
    }
  }
}

</script>

<style scoped>
.gap {
  gap: 10px;
}
</style>
